import dotenv from "dotenv";
import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import "./config/ReactotronConfig";
import { Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";

import Routes from "./routes";
import history from "./services/history";
import { store, persistor } from "./store";

import GlobalStyle from "./styles/global";
import { setDispatch } from "./services/socket";

dotenv.config();

function App() {
  setDispatch(store.dispatch);
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <Routes />
          <ToastContainer />
          <GlobalStyle />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
